import React, { useState } from "react";
import { Box, Container, Divider, Typography } from "@mui/material";
import Button from "../Button/Button";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import IosShareIcon from "@mui/icons-material/IosShare";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import Machine from "../../../assets/images/machine-imageview.png";
import Swipe from "../GalleryComponent/Swipe";
import SwipeableViews from "react-swipeable-views";

function ImageViewModal({ images, open, setOpen }) {
  const [ImagePos, setImagePos] = useState(0);
  const handleClose = () => setOpen(false);
  const mobMatch = useMediaQuery("(max-width:600px)");
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length;
  console.log(activeStep);
  const handleNext = () => {
    setActiveStep((prevActiveStep) =>
      activeStep === maxSteps - 1 ? prevActiveStep : prevActiveStep + 1
    );
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) =>
      activeStep === 0 ? prevActiveStep : prevActiveStep - 1
    );
  };

  const handleStepChange = (step) => {
    console.log(step,"working");
    setActiveStep(step);
  };
  return (
    <Modal
      sx={{ width: "100vw", background: "#000" }}
      hideBackdrop={true}
      open={open}
      onClose={handleClose}
    >
      <Box
        sx={{
          display: "flex",
          flexFlow: "column",
          width: "100%",
          height: "100%",
        }}
      >
        <Box
          sx={{
            padding: "16px 24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <CloseIcon
            onClick={handleClose}
            sx={{
              width: "24px",
              height: "24px",
              color: "#fff",
              "&:hover": {
                cursor: "pointer",
              },
            }}
          />
          <Typography
            variant="body2"
            sx={{ color: "#fff", fontSize: "14px", lineHeight: "20px" }}
          >
            {activeStep + 1 + "/" + maxSteps}
          </Typography>

          {mobMatch && (
            <Box sx={{ display: "flex", columnGap: "16px" }}>
              <FavoriteBorderIcon
                sx={{ color: "#fff", width: "32px", height: "32px" }}
              />
              <IosShareIcon
                sx={{ color: "#fff", width: "32px", height: "32px" }}
              />
            </Box>
          )}
          {!mobMatch && (
            <Box sx={{ display: "flex", columnGap: "16px" }}>
              <Button
                hoverBg="#fff"
                hoverTxColor="#000"
                variant="outlined"
                outColor="#808080"
                txColor="#fff"
                typoVariant="subtitle2"
                typoSize="14px"
                fontWeight="600"
                sx={{
                  "&:hover": {
                    backgroundColor: "#fff",
                    "& .MuiSvgIcon-root": {
                      fill: "#000",
                    },
                  },
                }}
                startIcon={
                  <IosShareIcon
                    sx={{ color: "#fff", width: "12px", height: "12px" }}
                  />
                }
              >
                Share
              </Button>
              <Button
                sx={{
                  "&:hover": {
                    backgroundColor: "#fff",
                    "& .MuiSvgIcon-root": {
                      fill: "#000",
                    },
                  },
                }}
                hoverBg="#fff"
                hoverTxColor="#000"
                variant="outlined"
                outColor="#808080"
                txColor="#fff"
                typoVariant="subtitle2"
                typoSize="14px"
                fontWeight="600"
                startIcon={
                  <FavoriteBorderIcon
                    sx={{ color: "#fff", width: "12px", height: "12px" }}
                  />
                }
              >
                Save
              </Button>
            </Box>
          )}
        </Box>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            paddingX: { sm: "24px" },
            justifyContent: "space-between",
          }}
        >
          {!mobMatch && (
            <Swipe
              onClick={handleBack}
              swipeStyle={{
                backgroundColor: "#000",
                border: "1px solid #808080",
                "&:hover": {
                  backgroundColor: "#FFF",
                  opacity: 1,
                  "& .MuiSvgIcon-root": {
                    fill: "#000",
                  },
                },
                display: activeStep === 0 && "none",
              }}
              arrowColor="#fff"
              direction="left"
            />
          )}
          <SwipeableViews
            axis={"x"}
            index={activeStep}
            onChangeIndex={handleStepChange}
            enableMouseEvents
              
>
            {images.map((step, index) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                key={index}
              >
                {Math.abs(activeStep - index) <= 2 ? (
                  <Box
                    component="img"
                    sx={{
                      maxWidth: { xs: "100%", md: "800px" },
                      height: { xs: "231px", md: "500px" },
                      display: "block",
                      overflow: "hidden",
                    }}
                    src={step}
                    alt={"machine"}
                  />
                ) : null}
              </div>
            ))}
          </SwipeableViews>

          {!mobMatch && (
            <Swipe
              onClick={handleNext}
              swipeStyle={{
                backgroundColor: "#000",
                border: "1px solid #808080",
                "&:hover": {
                  backgroundColor: "#FFF",
                  opacity: 1,
                  "& .MuiSvgIcon-root": {
                    fill: "#000",
                  },
                },
                display: activeStep === maxSteps - 1 && "none",
              }}
              arrowColor="#fff"
              direction="right"
            />
          )}
        </Box>
      </Box>
    </Modal>
  );
}

export default ImageViewModal;
